import React from "react";
import styles from './editStore.module.sass'
import StoreInformation from './StoreInformation';
import { ToastContainer } from "react-toastify";

const CreateStore = ({isChanged, setIsChanged}) => {
    return (
      <>
        <ToastContainer />
        <div className={styles.row}>
            <div className={styles.col}>
                <StoreInformation isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
            </div>
        </div>
      </>
    )
  }
  
  export default CreateStore